//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getTaskCommentApi, saveTaskCommentApi, putTaskCommentApi, deleteTaskCommentApi } from '@/api/program';
import imageViewer from '@/components/common/imageViewer';
var clickoutside = {
  // 初始化指令
  bind: function bind(el, binding, vnode) {
    function documentHandler(e) {
      // 这里判断点击的元素是否是本身，是本身，则返回
      if (el.contains(e.target)) {
        return false;
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(e);
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.vueClickOutside = documentHandler;
    document.addEventListener('click', documentHandler);
  },
  update: function update() {},
  unbind: function unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.vueClickOutside);
    delete el.vueClickOutside;
  }
};
export default {
  name: 'ArticleComment',
  components: {
    ueditorFrom: function ueditorFrom() {
      return import('@/components/form-common/oa-wangeditor');
    },
    defaultPage: function defaultPage() {
      return import('@/components/common/defaultPage');
    },
    imageViewer: imageViewer
  },
  props: {
    pid: {
      type: Number,
      default: 0
    },
    taskId: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      btnShow: false,
      showReply: false,
      index: '0',
      replyComment: '',
      myName: '',
      isEdit: false,
      myHeader: JSON.parse(localStorage.getItem('userInfo')).avatar,
      myId: JSON.parse(localStorage.getItem('userInfo')).id,
      to: '',
      toId: -1,
      comments: [],
      formData: {
        describe: ''
      },
      replyUid: 0,
      replyPid: 0,
      replyId: 0,
      srcList: []
    };
  },
  watch: {
    taskId: function taskId(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getTaskComment();
      }
    },
    'formData.describe': function formDataDescribe(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.formData.describe = newValue;
      }
    }
  },
  directives: {
    clickoutside: clickoutside
  },
  created: function created() {
    this.getTaskComment();
  },
  methods: {
    // 获取评论
    getTaskComment: function getTaskComment() {
      var _this = this;
      var data = {
        task_id: this.taskId
      };
      getTaskCommentApi(data).then(function (res) {
        _this.comments = res.data.list;
        _this.$emit('gettotalCount', res.data.total_count);
      });
    },
    inputFocus: function inputFocus() {
      var replyInput = document.getElementById('replyInput');
      replyInput.style.padding = '8px 8px';
    },
    showReplyBtn: function showReplyBtn() {
      this.btnShow = true;
    },
    hideReplyBtn: function hideReplyBtn() {
      this.btnShow = false;
      replyInput.style.padding = '10px';
      replyInput.style.border = 'none';
    },
    showReplyInput: function showReplyInput(i, name, id) {
      this.comments[this.index].inputShow = false;
      this.index = i;
      this.comments[i].inputShow = true;
      this.to = name;
      this.toId = id;
    },
    _inputShow: function _inputShow(i) {
      return this.comments[i].inputShow;
    },
    handleComment: function handleComment() {
      this.showReply = true;
      this.replyUid = '';
      this.replyPid = '';
    },
    showReplyEvt: function showReplyEvt(item, type) {
      this.isEdit = false;
      this.showReply = true;
      this.replyPid = type == 1 ? item.id : item.pid;
      this.replyUid = item.uid;
      if (type === 2) {
        var htmlContent = "<span style=\"font-size: 13px; color: #909399\">\u56DE\u590D</span><span style=\"font-size: 13px;\"> ".concat(item.member.name, "\uFF1A</span>").concat(this.formData.describe);
        this.formData.describe = htmlContent;
      }
    },
    // 发表评论
    sendComment: function sendComment() {
      var _this2 = this;
      if (!this.formData.describe) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '评论不能为空'
        });
      } else {
        var data = {
          pid: this.replyPid,
          task_id: this.taskId,
          reply_uid: this.replyUid,
          describe: this.formData.describe
        };
        if (this.isEdit) {
          putTaskCommentApi(this.replyId, data).then(function (res) {
            _this2.showReply = false;
            _this2.isEdit = false;
            _this2.getTaskComment();
            _this2.formData.describe = '';
          });
        } else {
          saveTaskCommentApi(data).then(function (res) {
            _this2.showReply = false;
            _this2.isEdit = false;
            _this2.getTaskComment();
            _this2.formData.describe = '';
          });
        }
      }
    },
    // 取消评论
    cancelComment: function cancelComment() {
      this.isEdit = false;
      this.showReply = false;
      this.formData.describe = '';
    },
    // 编辑评论
    eidtReply: function eidtReply(item) {
      this.showReply = true;
      this.isEdit = true;
      this.replyId = item.id;
      this.formData.describe = item.describe;
    },
    // 删除评论
    deleteReply: function deleteReply(item) {
      var _this3 = this;
      this.$modalSure('你确定要删除此评论吗').then(function () {
        deleteTaskCommentApi(item.id).then(function (res) {
          _this3.getTaskComment();
        });
      });
    },
    sendCommentReply: function sendCommentReply(i, j) {
      if (!this.replyComment) {
        this.$message({
          showClose: true,
          type: 'warning',
          message: '评论不能为空'
        });
      }
    },
    onDivInput: function onDivInput(e) {
      this.replyComment = e.target.innerHTML;
    },
    ueditorEdit: function ueditorEdit(e) {
      this.formData.describe = e;
    },
    //预览图片
    previewPicture: function previewPicture(e) {
      if (e.target.tagName == 'IMG') {
        this.srcList = [e.target.src];
        this.$refs.imageViewer.openImageViewer(e.target.src);
      }
    }
  }
};